//import Components
import ReactLoading from "react-loading";


//Component styling
const appStyle = {
    minHeight: "100vh"
};
const pageLoadingStyle = {
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center"
}

//----------------[Component - PageLoading]---------------------//
//render

export default function PageLoading () {
    return (
        <>
            <div className="App" style={appStyle}>
                <div className="page_loading" style={pageLoadingStyle}>

                    {/*Loading Component - spinning dots*/}
                    <ReactLoading delay={500} className="page-loading" type="spinningBubbles" color="#111111" height="10%" width="10%"/>
                </div>
            </div>
        </>
    )
}